import { createSlice } from '@reduxjs/toolkit';
export const InvoicePaymentStatuses = {
  IDLE: 'idle',
  PENDING: 'pending',
  POLLING: 'polling',
  COMPLETED_WITHOUT_TARGET: 'completedWithoutTarget'
};
const initialState = {
  status: InvoicePaymentStatuses.IDLE
};
const invoicePaymentSlice = createSlice({
  name: 'invoicePayment',
  initialState,
  reducers: {
    startInvoicePayment: (_state, action) => ({
      status: InvoicePaymentStatuses.PENDING,
      target: action.payload
    }),
    completeInvoicePayment: state => {
      if (state.status === InvoicePaymentStatuses.PENDING) {
        return {
          status: InvoicePaymentStatuses.POLLING,
          target: state.target
        };
      }
      if (state.status === InvoicePaymentStatuses.IDLE) {
        return {
          status: InvoicePaymentStatuses.COMPLETED_WITHOUT_TARGET
        };
      }
      return state;
    },
    clearInvoicePayment: () => ({
      status: InvoicePaymentStatuses.IDLE
    })
  }
});
export const selectInvoicePaymentStatus = state => state.invoicePayment.status;
export const selectInvoicePaymentTarget = state => {
  const slice = state.invoicePayment;
  return slice.status === InvoicePaymentStatuses.PENDING || slice.status === InvoicePaymentStatuses.POLLING ? slice.target : null;
};
export const {
  startInvoicePayment,
  completeInvoicePayment,
  clearInvoicePayment
} = invoicePaymentSlice.actions;
export default invoicePaymentSlice.reducer;